/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Capabilities_SubtitleInputs */

const en_landing_capabilities_subtitle = /** @type {(inputs: Landing_Capabilities_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move beyond static research reports to something your Sales & Trading desk can actually act on.`)
};

/**
* | output |
* | --- |
* | "Move beyond static research reports to something your Sales & Trading desk can actually act on." |
*
* @param {Landing_Capabilities_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_capabilities_subtitle = /** @type {((inputs?: Landing_Capabilities_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Capabilities_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_capabilities_subtitle(inputs)
});